const enableServices = () => {
  window.googletag.cmd.push(() => {
    window.googletag.enableServices();
  });
};

export default enableServices;
